import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import Grid, { Half } from 'grid-styled'
import TextArea from '../../components/Textarea'
import Button from '../../components/Button'
import Input from '../../components/Input'
import Avatar from '../../components/Avatar'
import { validateInput } from '../../Utils/Validations'
import { updateToken } from '../../actions/AuthActions'
import { Metrics, Fonts, Colors } from '../../Themes'
import SuccessModal from '../../components/Modal/SuccessModal'
import { updateUser } from '../../sources/AuthSources'
import ErrorModal from '../../components/Modal/ErrorModal'

const CustomHalf = styled(Half)`
  padding-top: ${Metrics.margins.base};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    padding-left: 0;
    padding-right: 0;
  }
`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};
  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    padding-left: 0;
    padding-right: 0;
  }
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
  color: ${Colors.black};

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    ${props => props.isUploadTitle && 'display: none'};
  }
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  margin-left: ${Metrics.margins.large};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const Container = styled.div`margin-top: ${Metrics.margins.larger};`

const CustomButton = styled(Button)`
  float: right;
  margin-top: ${Metrics.margins.larger};
  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    text-align: center;
    background: ${Colors.primary};
    color: ${Colors.whiteThree};
    float: inherit;
    width: 100%;
  }
`

class PersonalInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user,
      successModalOpen: false,
      fileUploadError: false,
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleProfilePictureUpload = this.handleProfilePictureUpload.bind(this)
    this.handleUploadError = this.handleUploadError.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ user: nextProps.user })
  }

  handleChange (event, key) {
    const user = this.state.user
    user[key] = event.target.value
    this.setState({ user })
  }

  handleProfilePictureUpload (file, result) {
    const user = this.state.user
    user.picture = { file, result }
    this.setState({ user, fileUploadError: false })
  }

  handleUploadError () {
    this.setState({ fileUploadError: true })
  }

  handleUpdate () {
    const { user } = this.state
    if (this.validateForm()) {
      updateUser(user)
        .then(response => {
          this.setState({ modal: 'success' }, () =>
            updateToken(response.data.authToken)
          )
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    }
  }

  handleCloseModal () {
    this.setState({ modal: false })
  }

  handleBlur (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  validateForm () {
    const requiredFields = document.querySelectorAll('[required]')
    let errors = this.state.errors
    let valid = true
    for (var k = 0; k < requiredFields.length; k++) {
      errors = validateInput(
        requiredFields[k].name,
        this.state.user[requiredFields[k].name],
        errors
      )
      valid = valid && errors[requiredFields[k].name] === ''
    }
    this.setState({ errors })
    return valid
  }

  render () {
    const { user, fileUploadError, errors, modal } = this.state
    const { t } = this.props
    return (
      <Container>
        <SuccessModal
          visible={modal === 'success'}
          closeAction={this.handleCloseModal}
          header={t('Profile Updated')}
          message={t('Your Profile was successfully updated')}
        />
        <ErrorModal
          visible={modal === 'error'}
          closeAction={this.handleCloseModal}
          header={t('Error')}
          message={t('There was an error when updating your profile')}
        />
        <CustomGrid noPadTop>
          <Title isUploadTitle>{t('Upload Picture')}</Title>
          <Avatar
            size={parseInt(Metrics.components.profilePhoto, 10)}
            imageSrc={user.picture && (user.picture.result || user.picture)}
            onEdit={this.handleProfilePictureUpload}
            handleError={this.handleUploadError}
            className='avatar'
          />
          {fileUploadError && <Error>{t('Max size 2MB')}</Error>}
        </CustomGrid>
        <CustomHalf>
          <Input
            title={t('First Name')}
            value={user.firstName}
            handleChange={event => this.handleChange(event, 'firstName')}
            required
            error={errors['firstName']}
            name='firstName'
            handleBlur={event =>
              this.handleBlur('firstName', user.firstName, errors)}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('E-mail')}
            value={user.email}
            handleChange={event => this.handleChange(event, 'email')}
            required
            error={errors['email']}
            name='email'
            handleBlur={event => this.handleBlur('email', user.email, errors)}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Last Name')}
            value={user.lastName}
            handleChange={event => this.handleChange(event, 'lastName')}
            required
            error={errors['lastName']}
            name='lastName'
            handleBlur={event =>
              this.handleBlur('lastName', user.lastName, errors)}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Phone Number')}
            value={user.phoneNumber}
            handleChange={event => this.handleChange(event, 'phoneNumber')}
            required
            error={errors['phoneNumber']}
            name='phoneNumber'
            handleBlur={event =>
              this.handleBlur('phoneNumber', user.phoneNumber, errors)}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Company')}
            value={user.company}
            handleChange={event => this.handleChange(event, 'company')}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Job Title')}
            value={user.jobTitle}
            handleChange={event => this.handleChange(event, 'jobTitle')}
          />
        </CustomHalf>
        <CustomGrid>
          <TextArea
            value={user.description}
            title={t('Brief Description')}
            handleChange={event => this.handleChange(event, 'description')}
          />
        </CustomGrid>
        <CustomGrid>
          <Input
            title={t('Address')}
            value={user.address}
            handleChange={event => this.handleChange(event, 'address')}
            required
            error={errors['address']}
            name='address'
            handleBlur={event =>
              this.handleBlur('address', user.address, errors)}
          />
        </CustomGrid>
        <CustomHalf>
          <Input
            title={t('City')}
            value={user.city}
            handleChange={event => this.handleChange(event, 'city')}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Country')}
            value={user.country}
            handleChange={event => this.handleChange(event, 'country')}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Skype Name')}
            value={user.skypeName}
            handleChange={event => this.handleChange(event, 'skypeName')}
          />
        </CustomHalf>
        <CustomHalf>
          <Input
            title={t('Linkedin Profile')}
            value={user.linkedinUrl}
            handleChange={event => this.handleChange(event, 'linkedinUrl')}
          />
        </CustomHalf>
        <CustomGrid noPadTop style={{ paddingBottom: Metrics.margins.base }}>
          <CustomButton label={t('Save')} onClick={this.handleUpdate} />
        </CustomGrid>
      </Container>
    )
  }
}

PersonalInfo.propTypes = {
  user: PropTypes.object,
  t: PropTypes.func
}

export default translate([ 'common', 'settings', 'forms' ], { wait: true })(
  PersonalInfo
)



// WEBPACK FOOTER //
// ./src/pages/ProfileSettings/PersonalInfo.js